import { TicketPack } from 'src/types/types';
import { API_URL } from 'src/utils/transport';
import { Button } from 'src/redesign/components/Button';

type PackPurchaseCardProps = {
  pack: TicketPack;
  isLoading: boolean;
  onPurchaseStart: () => void;
  onPurchaseComplete: () => void;
};

export const PackPurchaseCard = ({
  pack,
  isLoading,
  onPurchaseStart,
  onPurchaseComplete,
}: PackPurchaseCardProps) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  let instance = urlSearchParams.get('instance');

  if (!instance) {
    const hashFragment = window.location.hash.split('?')[1] || '';
    const hashParams = new URLSearchParams(hashFragment);
    instance = hashParams.get('instance');
  }

  return (
    <div className="col-6">
      <form
        action={
          window.brand === 'wix'
            ? `${API_URL}/api/v1/dashboard/billing/ticket-packs/purchase?instance=${instance}&brand=wix`
            : `${API_URL}/api/v1/dashboard/billing/ticket-packs/purchase`
        }
        method="POST"
        onSubmit={onPurchaseStart}
      >
        <input type="hidden" name="packId" value={pack.pack_id} />
        <div
          className="p-3 border-round text-center cursor-pointer"
          style={{
            border: '2px solid #e0e0e0',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = 'var(--brand-background-color)';
            e.currentTarget.style.backgroundColor = '#f8f4fc';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = '#e0e0e0';
            e.currentTarget.style.backgroundColor = 'white';
          }}
        >
          <div className="text-3xl font-bold mb-1">{pack.ticket_quota.toLocaleString()}</div>
          <div
            className="text-xl font-bold mb-2"
            style={{ color: 'var(--brand-background-color)' }}
          >
            ${pack.price}
          </div>
          <Button type="submit" disabled={isLoading} priority="secondary" size="medium" fullWidth>
            {isLoading ? 'Processing...' : 'Purchase'}
          </Button>
        </div>
      </form>
    </div>
  );
};
